import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"

export default function Toast() {
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      setMessage(detail?.message || String(detail))
      setTimeout(() => setMessage(null), 3000)
    }
    window.addEventListener("atlas:toast", handler)
    return () => window.removeEventListener("atlas:toast", handler)
  }, [])

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          className="fixed bottom-20 lg:bottom-6 left-3 right-3 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 z-[100] px-4 py-2.5 rounded-lg text-sm font-medium text-center bg-[#161821] border border-[#1e2130] text-[#f0f1f5] shadow-xl"
          role="status"
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
